import { render, staticRenderFns } from "./LongformContent.vue?vue&type=template&id=de1da472&scoped=true&"
import script from "./LongformContent.vue?vue&type=script&lang=js&"
export * from "./LongformContent.vue?vue&type=script&lang=js&"
import style0 from "./LongformContent.vue?vue&type=style&index=0&id=de1da472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1da472",
  null
  
)

export default component.exports